module.exports = __webpack_public_path__ + "static/media/boat-img-44.4519ba36.jpg";